export enum OrganizationMemberType {
  STAFF = 'STAFF',
  SERVER = 'SERVER',
  ADMIN = 'ADMIN',
}

export enum OrganizationMemberEvent {
  CREATED = 'TL_ORGANIZATION_MEMBER_CREATED',
  UPDATED = 'TL_ORGANIZATION_MEMBER_UPDATED',
  DELETED = 'TL_ORGANIZATION_MEMBER_DELETED',
}

export enum OrganizationMemberError {
  ORGANIZATION_ALREADY_HAS_OWNER = 'this organization already has an owner',
  CANNOT_DELETE_OWNER = 'cannot delete organization owner',
  CANNOT_REMOVE_OWNER_PERMISSION = 'cannot remove permission from organization owner',
  CANNOT_UNSET_OWNER = 'cannot unset organization owner',
  CANNOT_CHANGE_OWNER_DIRECTLY = 'ownership can only be changed with transfer ownership',
  ONLY_OWNER_OR_ADMIN_CAN_TRANSFER_OWNERSHIP = 'only the current owner or admin can transfer ownership',
  NEW_OWNER_MUST_BE_STAFF_IN_SAME_ORGANIZATION = 'new owner must be a staff member in the same organization',
  INVALID_OWNER_STATE = 'organization must have exactly one active owner',
  ORGANIZATION_REQUIRED = 'organization is required',
  ORGANIZATION_INVALID = 'organization is invalid',
  FIRST_NAME_INVALID = 'first name is invalid',
  LAST_NAME_INVALID = 'last name is invalid',
  TITLE_INVALID = 'title is invalid',
  PHONE_INVALID = 'phone is invalid',
  EMAIL_INVALID = 'email is invalid',
  EMAIL_ALREADY_PROMOTER_OR_PARTNER = 'this email is already a promoter or partner; remove them first before adding as staff',
  MANAGEMENT_USER_REQUIRED = 'management user required',
  MANAGEMENT_USER_EXISTS_FOR_ORG = 'email already exists within organization',
  VENUE_NOT_FOUND = 'venue not found',
  TYPE_INVALID = 'type invalid',
}
